export default __webpack_public_path__ + "static/media/bg.50b2dacb.50b2dacb.png";